import Index from "@frog/source/models/App.js"
import Navigation from "@frog/source/models/Navigation.js"
import * as Preact from "preact"

import "@frog/source/views/app/components/MiniMenu.view.less"

export default class MiniMenu {
    render() {
        if(Navigation.state.minimenu != undefined) {
            return (
                <div class="MiniMenu" onClick={this.onClickOutOfModal}>
                    <div class="Modal" onClick={this.onClickModal}>
                        <div class="Prompt">Quit?</div>
                        <div class="Options">
                            <div class="Yes" onClick={this.onClickQuitButton}>Yeah</div>
                            <div class="No" onClick={this.onClickOutOfModal}>Nah</div>
                        </div>
                    </div>
                </div>
            )
        }
    }
    onClickModal(event) {
        event.preventDefault()
        event.stopPropagation()
    }
    onClickOutOfModal(event) {
        Navigation.state.minimenu = undefined
    }
    onClickQuitButton(event) {
        console.log("YEAH")
        Navigation.state.minimenu = undefined
        // Navigation.go("/") // Splash Screen
        Navigation.state.screen = "SplashScreen"
    }
}
